import { SubmissionError } from 'redux-form';
import { REQUIRED_FIELDS } from './constants';
import { goToElement } from '../../utils/goToElement';

const getNestedValue = (obj, path) => path.split('.').reduce((acc, key) => acc?.[key], obj);

const setNestedError = (path, message) => path.split('.').reduceRight((acc, key) => ({ [key]: acc }), message);

export const transformToValidationErrors = errors =>
	Object.entries(errors).reduce((prev, [key, error]) => {
		if (key.includes('.')) {
			const nested = setNestedError(key, error);

			const [topKey] = key.split('.');

			return { ...prev, [topKey]: { ...(prev[topKey] || {}), ...nested[topKey] } };
		}

		return { ...prev, [key]: error };
	}, {});

export const validate = values => {
	REQUIRED_FIELDS.forEach(key => {
		if (values?.contact?.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.contact.email)) {
			throw new SubmissionError({ contact: { email: 'Не валидный email' } });
		}

		if (!getNestedValue(values, key)) {
			goToElement(key);
			throw new SubmissionError(setNestedError(key, 'Заполните это поле'));
		}
	});
};
